import { render } from "./Pie.vue?vue&type=template&id=a884ea30&scoped=true"
import script from "./Pie.vue?vue&type=script&lang=js"
export * from "./Pie.vue?vue&type=script&lang=js"

import "./Pie.vue?vue&type=style&index=0&id=a884ea30&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sharesight_partner_app/sharesight_partner_app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a884ea30"]])

export default __exports__